import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { State } from "reducers";
import { BuildingId } from 'shared/models';
import { getBuildingRequest } from "actions/buildingActions";
import { getBuilding, getIsLoadingBuilding } from "selectors/buildingsSelectors";
import { getAllBuildingOrgs } from "selectors/buildingOrgsSelectors";

export function useBuilding(buildingId: BuildingId | null, forceReload?: boolean) {
    const dispatch = useDispatch();
    const [ hasReloaded, setHasReloaded ] = useState<boolean>(false);
    
    const isLoading = useSelector((state: State) => buildingId ? getIsLoadingBuilding(state, { buildingId }) : false);
    const building = useSelector((state: State) => buildingId ? getBuilding(state, { buildingId }) : null);
    const allBuildingOrgs = useSelector((state: State) => buildingId ? getAllBuildingOrgs(state) : {});
    const buildingOrgs = (buildingId && allBuildingOrgs && allBuildingOrgs[buildingId]) || [];
    const infotainmentOrg = buildingOrgs.find(bo => bo.properties.isAdvertiser === true) || null;
    
    useEffect(() => {
        if (buildingId && ((!isLoading && !building) || (forceReload && !hasReloaded))) {
            dispatch(getBuildingRequest(buildingId));
            setHasReloaded(true);
        }
    }, [ buildingId, isLoading, building, dispatch, hasReloaded, forceReload ]);
   
    return {
        isLoadingBuilding: isLoading,
        building,
        infotainmentOrg,
    };
}
